import _ from 'lodash';
import { GET_EVENT_LIST } from '../../constants/ActionTypes';

const initialState = {
  error: null,
  loaded: false,
  loading: false,
  result: {},
  eventList: [],
};

/**
 * Event List Reducer
 * @param {*} state
 * @param {*} action
 */
export default function eventList(state = initialState, action = {}) {
  switch (action.type) {
    case `${GET_EVENT_LIST}_PENDING`:
      return {
        ...state,
        error: null,
        loading: true,
        loaded: false,
      };
    case `${GET_EVENT_LIST}_SUCCESS`:
      let eventList;
      if (action.bStart === 0) {
        eventList = action?.result?.data?.attributes?.items;
      } else {
        eventList = _.concat(
          state.eventList ?? [],
          action?.result?.data?.attributes?.items,
        );
      }
      return {
        ...state,
        error: null,
        result: action?.result,
        eventList: eventList,
        loaded: true,
        loading: false,
      };
    case `${GET_EVENT_LIST}_FAIL`:
      return {
        ...state,
        error: action.error,
        loading: false,
        loaded: false,
      };
    default:
      return state;
  }
}
